import API from "../api";

import { AxiosResponse } from "axios";
import { CommodityCode, RegionCommodityCode, SectionCommodityCode } from "../models/commodity.code";
import BaseService from "./_base.service";

const endpoint = "harmonized/commodities";

const CommodityCodeService = {
  ...BaseService<CommodityCode>({ endpoint }),
  async getSections(options?: any): Promise<AxiosResponse<SectionCommodityCode[]>> {
    return await API.get(`/${endpoint}/section`, { params: options });
  },
  async getRegions(options?: any): Promise<AxiosResponse<RegionCommodityCode[]>> {
    return await API.get(`/${endpoint}/region`, { params: options });
  },
  async switchStatus(commodityCodeId: number, companyId: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/switch`, { commodityCodeId, companyId });
  },
};

export default CommodityCodeService;
